import { render, staticRenderFns } from "./GFontFormInput.vue?vue&type=template&id=56078841&"
import script from "./GFontFormInput.vue?vue&type=script&lang=ts&"
export * from "./GFontFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GFontFormInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports